import { takeLatest, call, put, all } from 'redux-saga/effects';

import DomainActions from './domain-actions';
import DomainApi from './domain-api';

function* fetchDomains() {
  const response = yield call(DomainApi.fetchDomains);
  if (response.error) yield put(DomainActions.fetchDomainsFailure(response.error));
  else yield put(DomainActions.fetchDomainsSuccess(response));
}

function* fetchAvailableDomains({ payload: { channelTypeRef } }) {
  const response = yield call(DomainApi.fetchAvailableDomains, channelTypeRef);
  if (response.error) yield put(DomainActions.fetchAvailableDomainsFailure(response.error));
  else yield put(DomainActions.fetchAvailableDomainsSuccess(response));
}

function* domainSagas() {
  yield all([
    takeLatest(DomainActions.fetchDomains.getType(), fetchDomains),
    takeLatest(DomainActions.fetchAvailableDomains.getType(), fetchAvailableDomains),
  ]);
}

export default domainSagas;
